<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="timeout"
    absolute
  >
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        color="white"
        text
        v-bind="attrs"
        @click="show = false"
      >
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBar",
  data() {
    return {
      show: false,
      message: "",
      color: "success",
      timeout: 3000,
      location: "bottom",
    };
  },
  methods: {
    showMessage(message, options = {}) {
      this.message = message;
      this.color = options.color || "success";
      this.timeout = options.timeout || 3000;
      this.location = options.location || "bottom";
      this.show = true;
    },
  },
};
</script>
